module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('entity-page', {
    attrs: {
      "id": "page__additional_services_price",
      "loading": _vm.progress
    }
  }, [_c('template', {
    slot: "header-right"
  }, [_c('z-icon-button', {
    attrs: {
      "icon": ['fa', 'xmark'],
      "danger-light": "",
      "rounded": ""
    },
    on: {
      "click": _vm.back
    }
  }), _vm._v(" "), _c('z-icon-button', {
    attrs: {
      "icon": ['fa', 'check'],
      "success-light": "",
      "rounded": ""
    },
    on: {
      "click": _vm.save
    }
  })], 1), _vm._v(" "), _c('z-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "name": "service_id",
      "id": "service_id",
      "label": "Услуга",
      "required": true,
      "error": _vm.errors.first('service_id'),
      "data-vv-name": "service_id",
      "data-vv-as": ' '
    },
    on: {
      "change": _vm.clearPrice
    },
    model: {
      value: (_vm.price.service_id),
      callback: function($$v) {
        _vm.$set(_vm.price, "service_id", $$v)
      },
      expression: "price.service_id"
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selectd": "",
      "disabled": ""
    }
  }, [_vm._v("Не установлена")]), _vm._v(" "), _vm._l((Object.values(_vm.services)), function(service) {
    return _c('option', {
      domProps: {
        "value": service.id
      }
    }, [_vm._v(_vm._s(service.name))])
  })], 2), _vm._v(" "), (_vm.selectedService && ['grid-dimensions', 'grid-city-dimensions'].includes(_vm.selectedService.type)) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('z-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: ['grid-city', 'grid-city-dimensions'].includes(_vm.selectedService.type)
      }),
      expression: "{required: ['grid-city', 'grid-city-dimensions'].includes(selectedService.type)}"
    }],
    staticClass: "col-6",
    attrs: {
      "label": "Тип расчёта",
      "required": true,
      "name": "type",
      "id": "type",
      "data-vv-as": ' ',
      "error": _vm.errors.first('type')
    },
    model: {
      value: (_vm.price.type),
      callback: function($$v) {
        _vm.$set(_vm.price, "type", $$v)
      },
      expression: "price.type"
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Выбрать...")]), _vm._v(" "), _vm._l((_vm.selectedTypes), function(type) {
    return _c('option', {
      domProps: {
        "value": type.value
      }
    }, [_vm._v(_vm._s(type.name))])
  })], 2), _vm._v(" "), _c('z-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: ['grid-city', 'grid-city-dimensions'].includes(_vm.selectedService.type)
      }),
      expression: "{required: ['grid-city', 'grid-city-dimensions'].includes(selectedService.type)}"
    }],
    staticClass: "col-6",
    attrs: {
      "label": 'Тип расчёта цены по' + (parseInt(_vm.price.type) == 2 ? ' объёму' : ' весу'),
      "required": true,
      "name": "is_min",
      "id": "is_min",
      "data-vv-as": ' ',
      "error": _vm.errors.first('is_min')
    },
    model: {
      value: (_vm.price.is_min),
      callback: function($$v) {
        _vm.$set(_vm.price, "is_min", $$v)
      },
      expression: "price.is_min"
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Выбрать...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v(_vm._s('За единицу' + (parseInt(_vm.price.type) == 2 ? ' объёма' : ' веса')))]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v(_vm._s('За весь' + (parseInt(_vm.price.type) == 2 ? ' объём' : ' вес')))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: ['grid-city', 'grid-city-dimensions'].includes(_vm.selectedService.type),
        min_value: 0.000,
        max_value: 9999999999,
        decimal: [3, '.']
      }),
      expression: "{required: ['grid-city', 'grid-city-dimensions'].includes(selectedService.type), min_value: 0.000, max_value: 9999999999, decimal: [3, '.']}"
    }],
    staticClass: "col-6",
    attrs: {
      "label": ("Минимальный " + ((parseInt(_vm.price.type) == 1 ? ' вес' : ' объём'))),
      "name": "value_min",
      "id": "value_min",
      "data-vv-name": "value_min",
      "error": _vm.errors.first('value_min'),
      "type": "number",
      "data-vv-as": ' ',
      "required": ""
    },
    model: {
      value: (_vm.price.value_min),
      callback: function($$v) {
        _vm.$set(_vm.price, "value_min", $$v)
      },
      expression: "price.value_min"
    }
  }), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: ['grid-city', 'grid-city-dimensions'].includes(_vm.selectedService.type),
        min_value: 0.000,
        max_value: 9999999999,
        decimal: [3, '.']
      }),
      expression: "{required: ['grid-city', 'grid-city-dimensions'].includes(selectedService.type), min_value: 0.000, max_value: 9999999999, decimal: [3, '.']}"
    }],
    staticClass: "col-6",
    attrs: {
      "label": ("Максимальный " + ((parseInt(_vm.price.type) == 1 ? ' вес' : ' объём'))),
      "name": "value_max",
      "id": "value_max",
      "data-vv-name": "value_max",
      "error": _vm.errors.first('value_max'),
      "type": "number",
      "data-vv-as": ' ',
      "required": ""
    },
    model: {
      value: (_vm.price.value_max),
      callback: function($$v) {
        _vm.$set(_vm.price, "value_max", $$v)
      },
      expression: "price.value_max"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.selectedService && ['grid-city', 'grid-city-dimensions'].includes(_vm.selectedService.type)) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('z-input-autocomplete', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: false
      }),
      expression: "{required: false}"
    }],
    attrs: {
      "name": "city_id_from",
      "id": "city_id_from",
      "display-property": "name",
      "property": "id",
      "return": "id",
      "label": "Город отправления",
      "callback": _vm.getCities,
      "default": _vm.price.city && _vm.price.city.name ? _vm.price.city.name : '',
      "error": _vm.errors.first('city_id_from'),
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.price.city_id_from),
      callback: function($$v) {
        _vm.$set(_vm.price, "city_id_from", $$v)
      },
      expression: "price.city_id_from"
    }
  }), _vm._v(" "), _c('b', [_vm._v("или")]), _vm._v(" "), _c('z-input-autocomplete', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: false
      }),
      expression: "{required: false}"
    }],
    attrs: {
      "name": "zone_id_from",
      "id": "zone_id_from",
      "display-property": "name",
      "property": "id",
      "return": "id",
      "label": "Направление отправления",
      "callback": _vm.getZones,
      "default": _vm.price.zone && _vm.price.zone.name ? _vm.price.zone.name : '',
      "error": _vm.errors.first('zone_id_from'),
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.price.zone_id_from),
      callback: function($$v) {
        _vm.$set(_vm.price, "zone_id_from", $$v)
      },
      expression: "price.zone_id_from"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('z-input-autocomplete', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: false
      }),
      expression: "{required: false}"
    }],
    attrs: {
      "name": "city_id_to",
      "id": "city_id_to",
      "display-property": "name",
      "property": "id",
      "return": "id",
      "label": "Город назначения",
      "callback": _vm.getCities,
      "default": _vm.price.city && _vm.price.city.name ? _vm.price.city.name : '',
      "error": _vm.errors.first('city_id_to'),
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.price.city_id_to),
      callback: function($$v) {
        _vm.$set(_vm.price, "city_id_to", $$v)
      },
      expression: "price.city_id_to"
    }
  }), _vm._v(" "), _c('b', [_vm._v("или")]), _vm._v(" "), _c('z-input-autocomplete', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: false
      }),
      expression: "{required: false}"
    }],
    attrs: {
      "name": "zone_id_to",
      "id": "zone_id_to",
      "display-property": "name",
      "property": "id",
      "return": "id",
      "label": "Направление назначения",
      "callback": _vm.getZones,
      "default": _vm.price.zone && _vm.price.zone.name ? _vm.price.zone.name : '',
      "error": _vm.errors.first('zone_id_to'),
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.price.zone_id_to),
      callback: function($$v) {
        _vm.$set(_vm.price, "zone_id_to", $$v)
      },
      expression: "price.zone_id_to"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.selectedService && _vm.selectedService.type === 'grid-paymethod') ? _c('div', [_c('z-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "name": "payment_method_id",
      "id": "payment_method_id",
      "label": "Способ оплаты",
      "required": true,
      "error": _vm.errors.first('payment_method_id'),
      "data-vv-name": "payment_method_id",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.price.payment_method_id),
      callback: function($$v) {
        _vm.$set(_vm.price, "payment_method_id", $$v)
      },
      expression: "price.payment_method_id"
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selectd": "",
      "disabled": ""
    }
  }, [_vm._v("Не установлен")]), _vm._v(" "), _vm._l((Object.values(_vm.paymentMethods)), function(item) {
    return _c('option', {
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  })], 2)], 1) : _vm._e(), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        min_value: 0
      }),
      expression: "{required: true, min_value: 0}"
    }],
    attrs: {
      "name": "price",
      "id": "price",
      "label": "Цена (руб.)",
      "type": "number",
      "error": _vm.errors.first('price'),
      "required": true,
      "data-vv-name": "price",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.price.price),
      callback: function($$v) {
        _vm.$set(_vm.price, "price", $$v)
      },
      expression: "price.price"
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-600e7152","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/cost/views/additional_services/AdditionalServicesPrice.vue
// module id = 1164
// module chunks = 0